import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnChanges,
  ViewEncapsulation,
} from '@angular/core';
import { IconType } from '@shared/enums';
import { SvgIconType } from '@ngneat/svg-icon/lib/providers';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    class: 'icon',
  },
})
export class IconComponent implements OnChanges {
  @Input() name: string;
  @Input() type = IconType.SVG;
  @Input() size: 'xxs'|'xs' |'sm'| 'md' | 'lg' = 'md';
  @Input() direction?:string;
  @HostBinding('class') get iconSize(): string {
    const sizes = {
     xxxs: 'icon--xxxsmall',
      xxs: 'icon--xxsmall',
      xs: 'icon--xsmall',
      sm: 'icon--small',
      md: 'icon--medium',
      lg: '',
      xl: 'icon--large' };
    return this.size ? sizes[this.size] : sizes.md;
  }
  protected readonly IconType = IconType;
  nameAsIconType: SvgIconType;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnChanges(): void {
    this.changeDetectorRef.detectChanges();
    this.changeDetectorRef.markForCheck();
  }
}
